module.exports = __webpack_public_path__ + "img/medical_typography.1e4636e4.webp";